import { OnboardingStepScreen } from '@jonni/hooks/useOnboarding';
import { useMemo } from 'react';

const useStepFromUrl = (path: string): OnboardingStepScreen => {
  return useMemo(() => {
    if (!path) {
      return OnboardingStepScreen.WELCOME;
    }

    const normalizedPath = path.replace(/\/$/, '');
    const pathSegment = normalizedPath.split('/').pop() || '';
    const stepKey = pathSegment.replace(/-/g, '_').toUpperCase();

    // Check if the converted step key is a valid OnboardingStepScreen value
    return Object.values(OnboardingStepScreen).includes(stepKey as OnboardingStepScreen)
      ? (stepKey as OnboardingStepScreen)
      : OnboardingStepScreen.WELCOME;
  }, [path]);
};

export default useStepFromUrl;
